import React, { Component, useState } from "react";
import {
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
  ListItemButton,
  Collapse,
  List,
  SvgIcon,
} from "@mui/material";
import {
  HomeOutlined as IconHome,
  MenuOutlined as IconMenu,
  PowerSettingsNew as IconLogout,
  Group as IconUsers,
  InsertChart as IconChart,
  DashboardOutlined as IconDashboard,
  AccountBalance as IconOrg,
  SettingsOutlined as IconSettings,
  Margin as IconResourcePlanning,
  ModeOfTravelOutlined as IconTrip,
  LocalShippingOutlined as IconVehicle,
  PersonOutlined as IconDriver,
  CurrencyRupee as IconExpense,
  ExpandLess,
  ExpandMore,
  TextSnippetOutlined as IconReports,
  PushPinOutlined as IconPlacement,
  Groups as IconMeeting,
  Speed as IconOdometer,
  LocalGasStationOutlined as IconFuel,
  NoteAddOutlined as IconMaster,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";
import ConfirmDialog from "components/Custom/ConfirmDialog";

import { DEFAULTS, NOTIFY, LOCAL_STORAGE, CONFIG } from "common/config";
import { LABELS, ERRORS, SUCCESS, CONFIRMS } from "common/labels";
import { ApiLogin } from "apihandlers//login";
import { COMMON_JS } from "common/scripts";

const logoSmall = require("assets/images/logo.png");

const API_HANDLER_LOGIN = new ApiLogin();

const LeftBar = (props: any) => {
  const { page, setPage, userInfo } = props;
  const [leftBar, setLeftBar] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [showMasterMenu, setShowMasterMenu] = useState(false);

  const onUserLogout = () => {
    API_HANDLER_LOGIN.userLogout({}).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.LOGOUT_SUCCESS);
        localStorage.removeItem(LOCAL_STORAGE.USER_INFO);
        localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
        setLogoutPopup(false);
        setTimeout(() => {
          window.open("/login", "_self");
        }, 500);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.LOGOUT_FAILED);
      }
    });
  };

  const onSetLeftBar = (val: boolean) => {
    setLeftBar(val);
    if (val) {
      (document.querySelector(".content") as HTMLElement).classList.add(
        "active"
      );
    } else {
      (document.querySelector(".content") as HTMLElement).classList.remove(
        "active"
      );
      setShowMasterMenu(false);
    }
  };

  const roleId = userInfo.role.id;
  let mainMasterAccess = roleId === CONFIG.USER_ROLES.Admin;
  let tripEntryAccess =
    roleId === CONFIG.USER_ROLES.Admin ||
    roleId === CONFIG.USER_ROLES.Placement;

  let masterEntryLevel = false;
  let transactionEntryLevel = false;
  if (roleId === CONFIG.USER_ROLES.Admin) {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  } else {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  }

  let menuAdmin = roleId === CONFIG.USER_ROLES.Admin;

  return (
    <div className={"leftBar " + (leftBar ? "active" : "")}>
      <MenuList className="leftMenuWrapper">
        <MenuItem className={"leftMenu"} onClick={() => onSetLeftBar(!leftBar)}>
          <ListItemIcon>
            <IconMenu fontSize="small" />
          </ListItemIcon>
          <div>
            <h4>
              {CONFIG.SITE_NAME} <small>{CONFIG.VERSION}</small>
            </h4>
            {/* <img src={logoSmall} className="responsive" /> */}
          </div>
        </MenuItem>

        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.HOME || page === LABELS.MENU || page === ""
              ? "active"
              : "")
          }
          onClick={() => setPage(LABELS.HOME)}
        >
          <Tooltip title={LABELS.HOME} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconHome fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.HOME}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {masterEntryLevel && (
          <MenuItem
            className={"leftMenu " + (page === LABELS.REPORTS ? "active" : "")}
            onClick={() => setPage(LABELS.REPORTS)}
          >
            <Tooltip title={LABELS.REPORTS} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconDashboard fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.REPORTS}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {/* <MenuItem
          className={"leftMenu " + (page === LABELS.DASHBOARD ? "active" : "")}
          onClick={() => setPage(LABELS.DASHBOARD)}
        >
          <Tooltip title={LABELS.DASHBOARD} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconChart fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.DASHBOARD}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        <MenuItem
          className={"leftMenu " + (page === LABELS.MASTERS ? "active" : "")}
          onClick={() => setPage(LABELS.MASTERS)}
        >
          <Tooltip title={LABELS.MASTERS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconMaster fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.MASTERS}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {/* <MenuItem
          className={"leftMenu " + (page === LABELS.MY_MAP ? "active" : "")}
          onClick={() => setPage(LABELS.MY_MAP)}
        >
          <Tooltip title={LABELS.MY_MAP} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconMaster fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.MY_MAP}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        <MenuItem
          className={
            "leftMenu " + (page === LABELS.TRANSACTIONS ? "active" : "")
          }
          onClick={() => setPage(LABELS.TRANSACTIONS)}
        >
          <Tooltip title={LABELS.TRANSACTIONS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconReports fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.TRANSACTIONS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={"leftMenu " + (page === LABELS.TRIPS ? "active" : "")}
          onClick={() => setPage(LABELS.TRIPS)}
        >
          <Tooltip title={LABELS.TRIPS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconTrip fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.TRIPS}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {/* <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.TRANSACTION_BUTTON_ODO ? "active" : "")
          }
          onClick={() => setPage(LABELS.TRANSACTION_BUTTON_ODO)}
        >
          <Tooltip
            title={LABELS.TRANSACTION_BUTTON_ODO}
            placement={"right-start"}
          >
            <div>
              <ListItemIcon>
                <IconOdometer fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.TRANSACTION_BUTTON_ODO}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        <MenuItem
          className={"leftMenu " + (page === LABELS.PLACEMENT ? "active" : "")}
          onClick={() => setPage(LABELS.PLACEMENT)}
        >
          <Tooltip title={LABELS.PLACEMENT} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconPlacement fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.PLACEMENT}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.TRANSACTION_BUTTON_FUEL ? "active" : "")
          }
          onClick={() => setPage(LABELS.TRANSACTION_BUTTON_FUEL)}
        >
          <Tooltip
            title={LABELS.TRANSACTION_BUTTON_FUEL}
            placement={"right-start"}
          >
            <div>
              <ListItemIcon>
                <IconFuel fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.TRANSACTION_BUTTON_FUEL}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.MASTERS_BUTTON_VEHICLES ? "active" : "")
          }
          onClick={() => setPage(LABELS.MASTERS_BUTTON_VEHICLES)}
        >
          <Tooltip
            title={LABELS.MASTERS_BUTTON_VEHICLES}
            placement={"right-start"}
          >
            <div>
              <ListItemIcon>
                <IconVehicle fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.MASTERS_BUTTON_VEHICLES}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.MASTERS_BUTTON_DRIVERS ? "active" : "")
          }
          onClick={() => setPage(LABELS.MASTERS_BUTTON_DRIVERS)}
        >
          <Tooltip
            title={LABELS.MASTERS_BUTTON_DRIVERS}
            placement={"right-start"}
          >
            <div>
              <ListItemIcon>
                <IconDriver fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.MASTERS_BUTTON_DRIVERS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {/* <MenuItem
          className={
            "leftMenu " + (page === LABELS.MASTERS_BUTTON_USERS ? "active" : "")
          }
          onClick={() => setPage(LABELS.MASTERS_BUTTON_USERS)}
        >
          <Tooltip title={LABELS.MASTERS_BUTTON_USERS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconUsers fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.MASTERS_BUTTON_USERS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        <MenuItem
          className={"leftMenu " + (page === LABELS.SETTINGS ? "active" : "")}
          onClick={() => setPage(LABELS.SETTINGS)}
        >
          <Tooltip title={LABELS.SETTINGS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconSettings fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.SETTINGS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={"leftMenu " + (page === LABELS.LOGOUT ? "active" : "")}
          onClick={() => setLogoutPopup(!logoutPopup)}
        >
          <Tooltip title={LABELS.LOGOUT} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconLogout fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.LOGOUT}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
      </MenuList>

      <ConfirmDialog
        open={logoutPopup}
        title={LABELS.CONFIRM}
        msg={CONFIRMS.SURE_TO_LOGOUT}
        size={DEFAULTS.DIALOG_SIZE}
        onClose={() => setLogoutPopup(false)}
        onOk={onUserLogout}
      />
    </div>
  );
};

export default withSnackbar(LeftBar);
